import { useEffect } from 'react';
import { useSyncExternalStore } from 'react';
import { createLocalListStore } from '@/lib/localStore';

const recentStore = createLocalListStore('jjzc:recent');
const MAX_RECENT = 8;

export function useRecentViews() {
  const recentIds = useSyncExternalStore(
    recentStore.subscribe,
    recentStore.getSnapshot,
    recentStore.getSnapshot
  );

  return {
    recentIds,
    clearRecent: () => recentStore.set([]),
  };
}

export function useTrackRecentView(id?: string) {
  useEffect(() => {
    if (id) recentStore.addFront(id, MAX_RECENT);
  }, [id]);
}